import { notifications } from '@mantine/notifications';
import { useCallback, useState } from 'react';
import { useEditorStore } from '../store/editorStore';
import { useItemStyles } from './useItemStyles';
import { useVariables } from './useVariables';

export function useToolbar() {
  // State và actions từ store
  const items = useEditorStore((state) => state.items);
  const addItem = useEditorStore((state) => state.addItem);
  
  // Styles mặc định
  const { defaultTextStyle, defaultAITextStyle } = useItemStyles();
  
  // State cho modal upload
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const openUploadModal = () => setUploadModalOpen(true);
  const closeUploadModal = () => setUploadModalOpen(false);
  
  // Lấy danh sách biến
  const { variables } = useVariables();
  
  // Thêm text mới vào editor
  const handleAddText = useCallback(() => {
    const maxZIndex = Math.max(0, ...items.map(item => item.zIndex));
    
    addItem({
      type: 'text',
      content: 'Nhập nội dung văn bản ở đây',
      position: { x: 100, y: 100 },
      size: { width: 400, height: 100 },
      style: defaultTextStyle,
      zIndex: maxZIndex + 1,
    });
  }, [addItem, items, defaultTextStyle]);
  
  // Thêm AI text mới vào editor
  const handleAddAIText = useCallback(() => {
    const maxZIndex = Math.max(0, ...items.map(item => item.zIndex));
    
    addItem({
      type: 'ai-text',
      content: '',
      position: { x: 100, y: 150 },
      size: { width: 400, height: 200 },
      style: defaultAITextStyle,
      zIndex: maxZIndex + 1,
    });
    
    notifications.show({
      title: 'AI Text đã được tạo',
      message: 'Hãy nhập prompt và nhấn nút "Tạo văn bản từ prompt" để tạo nội dung',
      color: 'blue',
    });
  }, [addItem, items, defaultAITextStyle]);
  
  // Thêm auto-image mới vào editor
  const handleAddAutoImage = useCallback(() => {
    const maxZIndex = Math.max(0, ...items.map(item => item.zIndex));
    
    addItem({
      type: 'auto-image',
      content: 'thumbnail background',
      position: { x: 0, y: 0 },
      size: { width: 1280, height: 720 },
      style: {
        objectFit: 'cover',
        borderWidth: 0,
        borderColor: 'transparent',
      },
      zIndex: maxZIndex + 1,
      prompt: '',
    });
  }, [addItem, items]);
  
  // Thêm ảnh mới vào editor từ file đã chọn
  const handleImageUpload = useCallback((imageUrl: string) => {
    const maxZIndex = Math.max(0, ...items.map(item => item.zIndex));
    
    addItem({
      type: 'image',
      content: imageUrl,
      position: { x: 0, y: 0 },
      size: { width: 500, height: 300 },
      style: {
        objectFit: 'contain',
        borderWidth: 0,
        borderColor: 'transparent',
      },
      zIndex: maxZIndex + 1,
    });
    
    // Đóng modal upload
    closeUploadModal();
  }, [addItem, closeUploadModal, items]);
  
  return {
    uploadModalOpen,
    openUploadModal,
    closeUploadModal,
    handleAddText,
    handleAddAIText,
    handleAddAutoImage,
    handleImageUpload,
  };
} 